export default (previousState={}, { type, payload }) => {
  if (type === '@@router/LOCATION_CHANGE') {
    return {
      pathname: payload.pathname,
      changed: previousState.pathname !== payload.pathname
    }
  }
  return previousState;
}
